import Avatar from './Avatar';
import DateComponent from './Date';
import CoverImage from './CoverImage';
import PostTitle from './PostTitle';
import { useRouter } from 'next/router';

export default function PostHeader({ title, coverImage, date, author, slug }) {
  const router = useRouter();
  const app = router.query.app;
  const link = `/blog/${slug}${app ? '?app=true' : ''}`;

  return (
    <>
      <PostTitle>{title}</PostTitle>
      <div className="xs:px-0 lg:px-40 mb-8 md:mb-16 sm:mx-0">
        <CoverImage
          title={title}
          url={coverImage.url}
          slug={slug}
          width={coverImage.width}
          height={coverImage.height}
          link={link}
        />
      </div>
      <div className="max-w-2xl mx-auto">
        <div className="mb-6">
          {author && <Avatar name={author.name} picture={author.picture} />}
        </div>
        <div className="mb-6 text-lg font-medium">
          <DateComponent dateString={date} />
        </div>
      </div>
    </>
  );
}
